import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"

import { useAuth } from "@/auth/useAuth"
import { queryKeys } from "@/config/query-keys"
import { CustomerApi } from "@/lib/customer-api"
import { getApiErrorMessage } from "@/lib/error-codes"

export function useCustomerProfile() {
  const { selectedCustomer } = useAuth()
  const queryClient = useQueryClient()
  const customerId = selectedCustomer?.customerId

  const query = useQuery({
    queryKey: queryKeys.customer.me(customerId ?? 0),
    queryFn: () => CustomerApi.getMe(),
    enabled: customerId != null,
  })

  const updateMarketing = useMutation({
    mutationFn: (marketing: boolean) => CustomerApi.updateMe({ marketing }),
    onSuccess: (customer) => {
      if (customerId != null) {
        queryClient.setQueryData(queryKeys.customer.me(customerId), customer)
      }
    },
    // The switch shows what apostle holds, so a refused change springs back; the toast says it did not save.
    onError: (error: unknown) => {
      toast.error(getApiErrorMessage(error))
    },
  })

  return {
    profile: query.data ?? selectedCustomer,
    isLoading: query.isLoading,
    updateMarketing,
  }
}
